module.exports = __webpack_public_path__ + "1c39703ccc2b224599acd12f0811722a.png";